export const AMBER = "var(--glow-lists)";
export const MEALS = ["breakfast", "lunch", "dinner"];
export const MEAL_LABEL = { breakfast: "Breakfast", lunch: "Lunch", dinner: "Dinner" };

// Dates are hub-local YYYY-MM-DD strings; format them in UTC so the viewer's own time zone never shifts the day.
const at = (iso) => new Date(`${iso}T12:00:00Z`);
export const dayShort = (iso) => at(iso).toLocaleDateString("en-US", { weekday: "short", timeZone: "UTC" });
export const dayLong = (iso) => at(iso).toLocaleDateString("en-US", { weekday: "long", month: "short", day: "numeric", timeZone: "UTC" });
export const dayNum = (iso) => at(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: "UTC" });
export const addDays = (iso, n) => { const d = at(iso); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };

export const ingLine = (i) => [i.qty, i.unit, i.item].filter(Boolean).join(" ");
export const parseIngredients = (text) => text.split("\n").map((l) => l.trim()).filter(Boolean).map((l) => {
  const m = l.match(/^([\d\s/.½¼¾]+)?\s*(cups?|tbsp|tsp|tablespoons?|teaspoons?|lbs?|pounds?|oz|ounces?|g|kg|ml|l|cloves?|cans?|slices?|pinch|bunch|jars?|packages?)?\s+(.+)$/i);
  if (!m) return { qty: null, unit: null, item: l };
  return { qty: (m[1] || "").trim() || null, unit: m[2] || null, item: m[3].trim() };
});
